import { get } from 'lodash';

import type { SearchType } from '@lt/api/dist/types/searchParams';
import { SEARCH_TYPE_NAMES } from '../../../components/Cigarette/constants';
import { useGetSearchParams } from './useGetSearchParams';

export const useGetSearchType = (): SearchType => {
  const searchParams = useGetSearchParams();

  return get(searchParams, 'search_type', SEARCH_TYPE_NAMES.PACKAGE);
};
